
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarService } from './toolbar.service';

declare var module: any;

export interface C4ToolbarAction {
  /**
   * Specifies the name of the action to be dispatched through the C4Toolbar <code>action</code>
   * output when the given action is invoked.
   */
  name: string;
  /**
   * (optional) Specfies the full icon class name (e.g., "fa fa-fw fa-bolt") to be used to render
   * an icon with the action.
   */
  iconClass?: string;
  /**
   * (optional) Specifies the textual label to be rendered for the action.
   */
  label?: string;
}

/**
 * This component renders a simple toolbar with a title, subtitle and list of action
 * links, all of which are opitonal.  To configure the actions, bind an array of
 * C4ToolbarAction objects to the <code>actions</code> input.  To be notified of an action
 * being invoked, bind to the <code>action</code> output.  The subscriber to that output
 * will receive an object with both the click event and the name of the action that was
 * invoked.
 */
@Component({
  selector: 'c4-toolbar',
  templateUrl: './toolbar.html',
  styleUrls: ['./toolbar.css'],
})
export class C4Toolbar {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() actions: Array<C4ToolbarAction>;

  @Output() action: EventEmitter<any>;

  constructor(
    private toolbarService: ToolbarService
  ) {
    this.action = new EventEmitter<any>();
    this.actions = [];
  }

  emitAction(event: any, action: string) {
    this.action.next({ event: event, action: action });
  }

  toggleSidebar() {
    this.toolbarService.toggleSidebar();
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/toolbar/toolbar.ts